import React from "react";

const DiscountReviewIndex = () => {
  return (
    <div>DiscountReviewIndex</div>
  )
}

export default DiscountReviewIndex;